import React from "react";
import { useLicense } from "../../hooks/useLicense";

const Pill = ({ tone = "neutral", children }) => {
  const tones = {
    neutral: "bg-gray-700 text-gray-300",
    ok: "bg-emerald-900/40 text-emerald-300 border border-emerald-800",
    warn: "bg-amber-900/40 text-amber-300 border border-amber-800",
    off: "bg-red-900/30 text-red-300 border border-red-900",
  };
  return (
    <span className={`px-2 py-0.5 text-xs rounded-md ${tones[tone]}`}>
      {children}
    </span>
  );
};

export default function LicensePanel() {
  const {
    loading,
    seats,
    companyHasOctopushX,
    companyHasRecordingStudio,
    tier,
  } = useLicense();

  if (loading) return null;

  return (
    <div className="bg-[#0C0E12] border border-gray-700 rounded-lg p-5 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-white font-medium text-base">Licenses & seats</h3>
          <p className="text-gray-400 text-xs">
            Seat totals reflect users plus pending invitations.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Octopush X */}
        <div className="bg-[#13161B] border border-gray-800 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-white text-sm font-medium">Octopush X</span>
            {companyHasOctopushX ? (
              <Pill tone="ok">Active</Pill>
            ) : (
              <Pill tone="off">Not licensed</Pill>
            )}
          </div>
          {companyHasOctopushX ? (
            <>
              <div className="text-2xl text-white font-semibold">
                {seats.octopushX.used}
                <span className="text-gray-500 text-base">
                  {" "}
                  / {seats.octopushX.max}
                </span>
              </div>
              <p className="text-xs text-gray-400 mt-1">
                {seats.octopushX.available} seats available
              </p>
            </>
          ) : (
            <p className="text-xs text-gray-500">
              Your plan doesn't include Octopush X.
            </p>
          )}
        </div>

        {/* Recording Studio */}
        <div className="bg-[#13161B] border border-gray-800 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-white text-sm font-medium">
              Recording Studio
            </span>
            {companyHasRecordingStudio ? (
              <Pill tone="ok">{tier || "Active"}</Pill>
            ) : (
              <Pill tone="off">Not licensed</Pill>
            )}
          </div>
          {companyHasRecordingStudio ? (
            <>
              <div className="text-2xl text-white font-semibold">
                {seats.recordingStudio.used}
                <span className="text-gray-500 text-base">
                  {" "}
                  / {seats.recordingStudio.max}
                </span>
              </div>
              <p className="text-xs text-gray-400 mt-1">
                {seats.recordingStudio.available} seats available
              </p>
            </>
          ) : (
            <p className="text-xs text-gray-500">
              Your plan doesn't include the Recording Studio.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
